"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _autoFocusDisabled = require("./autoFocusDisabled");
Object.keys(_autoFocusDisabled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _autoFocusDisabled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _autoFocusDisabled[key];
    }
  });
});